// extracted by mini-css-extract-plugin
export var anticlockwise = "cj_kM";
export var svg = "cj_kK";
export var wrapper = "cj_B";
export var wrapperFlexCenter = "cj_kL";